module.exports = __webpack_public_path__ + "img/Hygiènes_cover.47c1b645.jpg";